export enum ConnectivityStatus {
  OFFLINE = 'OFFLINE',
  ONLINE = 'ONLINE',
  WAS_NEVER_ONLINE = 'WAS_NEVER_ONLINE',
}
